import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { SoundsFamiliar } from './components/sections/SoundsFamiliar';
import { WhatsInside } from './components/sections/WhatsInside';
import { AlsoGet } from './components/sections/AlsoGet';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
type AppProps = {
  showPurchaseNotifications?: boolean;
  showFloatingCta?: boolean;
};
export function App({
  showPurchaseNotifications = true,
  showFloatingCta = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3mj6k9yvk64h1">
      <MetaPixel data-id="element-1" data-mp="3rbzo8kj7d8s2" />
      <main className="w-full" data-id="element-2" data-mp="3rdkg22e4udm8">
        <Hero data-id="element-3" data-mp="3recc1ebn6dd1" />
        <Stats data-id="element-4" data-mp="5yhupa6n3cr" />
        <BeforeAfter data-id="element-5" data-mp="6hp9c27i9cj" />
        <SoundsFamiliar data-id="element-6" data-mp="4wyzymxdckh" />
        <WhatsInside data-id="element-7" data-mp="56m9egl55mh" />
        <AlsoGet data-id="element-8" data-mp="7sxpp6lk59z" />
        <Bonuses data-id="element-9" data-mp="2zld43f9knpe6" />
        <Offer data-id="element-10" data-mp="2zlv32jnmchps" />
        <Guarantee data-id="element-11" data-mp="2zmemy5wtxg6g" />
        <Testimonials data-id="element-12" data-mp="2zmwl5831y4h0" />
        <About data-id="element-13" data-mp="33mow1rfx4mpj" />
        <Faq data-id="element-14" data-mp="33m5am0r27g6r" />
        <FinalCta data-id="element-15" data-mp="33lx0uhq8gqzs" />
      </main>
      <Footer data-id="element-16" data-mp="33mymfg4vkvvr" />
      {showFloatingCta ? <FloatingCta data-id="element-17" data-mp="38lrpsfqg76i7" /> : null}
      {showPurchaseNotifications ? <PurchaseToast data-id="element-18" data-mp="38k6w0sbyjrle" /> : null}
    </div>;
}